<template>
    <div class="layout">
        <div id="layout-title">
            <div id="layout-title-left">
                 <img src="/static/imgs/yonghu.png" class="jxyd-imgicon" />
                用户管理
            </div>
            <div id="layout-title-right">
                <button class='jxyd-button' title="新建用户" @click="addUser" style="margin-right:10px;" v-show="permission.isAdd">
                    <Icon type="md-add-circle" size='18'/> 新建
                </button>
                <button class='jxyd-button' title="删除用户" @click="deleteUser" v-show="permission.isDelete">
                    <Icon type="md-trash" size='18'/> 删除
                </button>
            </div>
        </div>

        <div id="layout-box">
            <div id="box-search">
                <Form ref="formSearch" :model="searchItems" inline>
                    <FormItem>
                        <Input type="text" v-model="searchItems.userDisplayName" placeholder="用户姓名" @keyup.enter.native="initListData(1)" />
                    </FormItem>
                    <FormItem>
                        <Input type="text" v-model="searchItems.loginCode" placeholder="用户账号" @keyup.enter.native="initListData(1)" />
                    </FormItem>
                    <FormItem>
                        <button class="jxyd-button jxyd-primary" @click="initListData(1)">查询</button>
                    </FormItem>
                </Form>
            </div>
            <div id="box-table">
                <Table ref="userList" :columns="tableColumns" :data="userData" @on-selection-change="userListSeleChange"></Table>
            </div>
            <div id="page-box">
                <Page :total="userCount" :page-size="searchItems.pageSize"
                      @on-change="pageChange" show-total
                      :current="searchItems.pageIndex"
                      style="display:inline-block;">
                </Page>
            </div>
        </div>

        <Modal v-model="modalDisPlay" draggable sticky scrollable :width="550">
            <p slot="header" class="modal-header">
                <img src="/static/imgs/bianjiyonghu.png" class="jxyd-imgicon" />
                <span> 操作用户</span>
            </p>
            <Form ref="formUser" :model="formItem" :label-width="70" :rules="ruleUser">
                <table style="width:100%;background-color:#fff;padding:20px;border-radius:5px;">
                    <tr>
                        <td rowspan="2">
                            <Upload action="/file/file/UploadImg"
                                    :show-upload-list="false"
                                    :max-size="2048"
                                    :format="['jpg','jpeg','png','gif']"
                                    :on-format-error="uploadImgFormatError"
                                    :on-exceeded-size="uploadImgSizeError"
                                    :on-success="upLoadSuccess"
                                    :on-error="upLoadError">
                                <Avatar id="head-img-ava" :src="formItem.headImg" size="100" />
                            </Upload>
                        </td>
                        <td>
                            <Form-item label="用户名" prop="userDisplayName">
                                <Input v-model="formItem.userDisplayName" placeholder="请输入" size="large" />
                            </Form-item>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <Form-item label="账号" prop="loginCode">
                                <Input v-model="formItem.loginCode" placeholder="请输入" size="large" />
                            </Form-item>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <Form-item label="密码" prop="pwd">
                                <Input type="password" v-model="formItem.pwd" placeholder="请输入" size="large" />
                            </Form-item>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <Form-item label="确认密码" prop="pwdCheck">
                                <Input type="password" v-model="formItem.pwdCheck" placeholder="请输入" size="large" />
                            </Form-item>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <Form-item label="性别">
                                <Radio-group v-model="formItem.sex" size="large">
                                    <Radio label="1">男</Radio>
                                    <Radio label="0">女</Radio>
                                </Radio-group>
                            </Form-item>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <Form-item label="身份证" prop="identityId">
                                <Input v-model="formItem.identityId" placeholder="请输入" size="large" />
                            </Form-item>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <Form-item label="电话" prop="telePhone">
                                <Input v-model="formItem.telePhone" placeholder="请输入" size="large" />
                            </Form-item>
                        </td>
                    </tr>
                </table>
            </Form>

            <div slot="footer">
                <button class="jxyd-button" @click="cancel('formUser')">取消</button>
                <button class="jxyd-button jxyd-primary" @click="userSubmit('formUser')">保存</button>
            </div>
        </Modal>
    </div>
</template>

<script>
    import request from '@/utils/request'

    export default {
        name: 'usermanage',
        data() {
            return {
                searchItems: {
                    loginCode: '',
                    userDisplayName: '',
                    pageSize: 11,
                    pageIndex: 1,
                },
                userCount: 0,
                modalDisPlay: false,
                tableColumns: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: '姓名',
                        key: 'userDisplayName'
                    },
                    {
                        title: '账号',
                        key: 'loginCode'
                    },
                    {
                        title: '性别',
                        key: 'sex',
                        // render(h, params) {
                        //     return h('svg', {
                        //         style: {
                        //             fontSize: 25
                        //         },
                        //         attrs: {
                        //             class: "icon"
                        //         }
                        //     }, [(params.row.sex == "0" ? h('use', {
                        //         attrs: {
                        //             'xlink:href': '#icon-a-16nvxingjiaose'
                        //         }
                        //     }) : h('use', {
                        //         attrs: {
                        //             'xlink:href': '#icon-a-15nanxingjiaose'
                        //         }
                        //     }))])
                        // }
                    },
                    {
                        title: '电话',
                        key: 'telePhone'
                    },
                    {
                        title: '身份证',
                        key: 'identityId'
                    },
                    {
                        title: '账号状态',
                        key: 'accountStatus',
                        render(h, params) {
                            return h('span', {
                                style: {
                                },
                                attrs: {
                                },
                                on: {
                                    click: (e) => {
                                    }
                                }
                            }, (params.row.accountStatus == "0" ? "在职" : "离职"))
                        }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        width: 150,
                        align: 'center',
                        fixed: 'right',
                        render: (h, params) => {
							var btnArr = [];
							if (this.permission.isEdit) {
							    btnArr.push(h('a', {
									class:['jxyd-a'],
							        style: {
							            'margin-right': '5px'
							        },
							        attrs: {
							        },
							        on: {
							            click: (e) => {
                                            this.initForm(params.row);
                                            this.modalDisPlay = true;
							            }
							        },
							    }, "编辑"));
							}
							return btnArr;
                        }
                    }
                ],
                userData: [],
                formItem: {
                    id: 0,
                    loginCode: '',
                    pwd: '',
                    pwdCheck: '',
                    userDisplayName: '',
                    headImg: '',
                    sex: '1',
                    identityId: '',
                    telePhone: '',
                    accountStatus: '0',
                    creator: parseInt(localStorage.getItem("userId"))
                },
                ruleUser: {
                    loginCode: [
                        { required: true, message: '请填写账号', trigger: 'blur' },
                        { type: 'string', max: 20, message: '输入不得大于20个字', trigger: 'blur' }
                    ],
                    pwd: [
                        { validator: this.validatePass, trigger: 'blur' },
                        { type: 'string', max: 20, message: '输入不得大于20个字', trigger: 'blur' }
                    ],
                    pwdCheck: [
                        { validator: this.validatePassCheck, trigger: 'blur' },
                        { type: 'string', max: 20, message: '输入不得大于20个字', trigger: 'blur' }
                    ],
                    userDisplayName: [
                        { required: true, message: '请填写用户名', trigger: 'blur' },
                        { type: 'string', max: 20, message: '输入不得大于20个字', trigger: 'blur' }
                    ],
                    identityId: [
                        { required: true, message: '请填写身份证', trigger: 'blur' },
                        { type: 'string', min: 18, max: 18, message: '身份证号必须为18位', trigger: 'blur' }
                    ],
                    telePhone: [
                        { type: 'string', max: 11, message: '电话号最大为11位', trigger: 'blur' }
                    ]
                },
                tableRowIds: [],
                permission: {
                    isAdd: false,
                    isEdit: false,
                    isDelete: false,
                    isUpdateUse: false
                }
            }
        },

        methods: {
            initListData(index) {
                let component = this;
                component.searchItems.pageIndex = index;
                request.post('/api/User/GetUserList', component.searchItems).then(function (response) {
                    if (response.state == 0) {
                        component.$Notice.error({
                            title: '错误提示',
                            duration: 3,
                            desc: "获取数据失败：" + response.errorMsg
                        });
                        return;
                    }
                    component.userData = response.data.user;
                    component.userCount = response.data.userCount;
                }).catch(function (error) {
                })
            },
            initForm(data) {
                this.formItem.id = data.id;
                this.formItem.loginCode = data.loginCode;
                this.formItem.pwd = data.pwd;
                this.formItem.pwdCheck = data.pwdCheck;
                this.formItem.userDisplayName = data.userDisplayName;
                this.formItem.headImg = data.headImg;
                this.formItem.sex = data.sex;
                this.formItem.identityId = data.identityId;
                this.formItem.telePhone = data.telePhone;
                this.formItem.accountStatus = data.accountStatus;
                this.formItem.creator = data.creator;
                this.formItem.createDate = data.createDate;
            },
            userSubmit(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        let component = this;
                        if (component.formItem.id < 1) {
                            for (var i = 0; i < component.userData.length; i++) {
                                if (component.userData[i].loginCode == component.formItem.loginCode) {
                                    this.$Message.error('账号已存在!');
                                    return;
                                }

                                if (component.userData[i].identityId == component.formItem.identityId) {
                                    this.$Message.error('身份证号已存在!');
                                    return;
                                }
                            }
                        }

                        request.post('/api/User/EditUser', component.formItem).then(function (response) {
                            if (response.state == 0) {
                                component.$Notice.error({
                                    title: '错误提示', duration: 3,
                                    desc: '保存失败:' + response.errorMsg
                                });
                                return;
                            }
                            //清空form规则检查
                            component.modalDisPlay = false;
                            component.initListData(1);
                            component.$Notice.success({
                                title: '正确提示', duration: 3,
                                desc: '保存成功!'
                            });

                        }).catch(function (error) {
                        })
                    }
                })
            },
            cancel(name) {
                this.modalDisPlay = false;
                //清空form规则检查
                this.$refs[name].resetFields();
            },
            addUser() {
                this.modalDisPlay = true;
                this.$refs['formUser'].resetFields();
                this.formItem.id = 0;
            },
            userListSeleChange(items) {
                this.tableRowIds = [];
                for (var i = 0; i < items.length; i++) {
                    this.tableRowIds.push(items[i].id);
                }
            },
            deleteUser() {
                if (this.tableRowIds.length <= 0) {
                    this.$Notice.error({
                        title: '错误提示',
                        duration: 3,
                        desc: '请选中要删除的用户！'
                    });
                    return;
                }
                var component = this;
                this.$Modal.confirm({
                    title: "操作警告",
                    content: "用户删除后不可恢复，是否继续操作？",
                    onOk() {
                        request.post('/api/User/DeleUser', component.tableRowIds).then(function (response) {

                            if (response.state == 0) {
                                component.$Notice.error({
                                    title: '错误提示', duration: 3,
                                    desc: response.errorMsg
                                });
                                return;
                            }
                            component.initListData(1);
                            component.tableRowIds = [];
                        }).catch(function (error) {
                        })
                    },
                    onCancel() {
                    }
                });
            },
            upLoadSuccess(response, file, fileList) {
                if (response.state == 0) {
                    this.$Notice.error({
                        title: '错误提示', duration: 3,
                        desc: '上传失败：' + response.errorMsg + '!'
                    });
                    return;
                }
                this.formItem.headImg = response.data[0];
            },
            upLoadError(error, file, fileList) {
                this.$Notice.error({
                    title: '错误提示', duration: 3,
                    desc: '上传失败：' + error + '!'
                });
            },
            uploadImgFormatError(file) {
                this.$Notice.error({
                    title: '错误提示', duration: 3,
                    desc: '上传失败：请上传jpg、png、jpeg、gif格式图片!'
                });
            },
            uploadImgSizeError(file) {
                this.$Notice.error({
                    title: '错误提示', duration: 3,
                    desc: '上传失败：不可上传超过2M大小图片!'
                });
            },
            validatePass(rule, value, callback) {
                if (value === '') {
                    callback(new Error('请填写密码'));
                } else {
                    if (this.formItem.pwdCheck !== '') {
                        // 对第二个密码框单独验证
                        this.$refs.formUser.validateField('pwdCheck');
                    }
                    callback();
                }
            },
            validatePassCheck(rule, value, callback) {
                if (value === '') {
                    callback(new Error('请再次确认密码'));
                } else if (value !== this.formItem.pwd) {
                    callback(new Error('两次密码输入不一致!'));
                } else {
                    callback();
                }
            },
            pageChange(index) {
                this.initListData(index);
            },
            initPermission() {
                let self = this;
                let params = {
                    funcCodes: ['User.Add', 'User.Edit', 'User.Delete', 'User.UpdateUse'],
                    userId: parseInt(localStorage.getItem("userId"))
                };
                request.post('/api/Function/VerifyPermissions', params).then(function (response) {
                    let tipTimeoutCount = localStorage.getItem("_tipTimeoutCount")
					if(tipTimeoutCount != undefined){
						tipTimeoutCount = parseInt(tipTimeoutCount);
					}
                    if (response.state == 0) {
                    	self.$Notice.error({
                    		title: '错误提示',
                    		duration: 3,
                    		desc: "获取权限数据失败：" + response.errorMsg
                    	});
                    	return;
                    }else if(response.state == 2 && (tipTimeoutCount == undefined || tipTimeoutCount >= 1000)){
                    	self.$Modal.warning({
                    		title:'系统到期提示',
                    		content: response.errorMsg,
                    		onOk:() => {
                    			localStorage.setItem("_tipTimeoutCount",1);
                    		}
                    	});
                    }
                    if(tipTimeoutCount == undefined || tipTimeoutCount < 1000){
                    	localStorage.setItem("_tipTimeoutCount",tipTimeoutCount == undefined ? 1 : tipTimeoutCount+1)
                    }
                    for (var i = 0; i < response.data.length; i++) {
                        switch (response.data[i].funcCode) {
                            case 'User.Add':
                                self.permission.isAdd = response.data[i].permission
                                break;
                            case 'User.Edit':
                                self.permission.isEdit = response.data[i].permission
                                break;
                            case 'User.Delete':
                                self.permission.isDelete = response.data[i].permission
                                break;
                            case 'User.UpdateUse':
                                self.permission.isUpdateUse = response.data[i].permission
                                break;
                        }
                    }
                }).catch(function (error) {
                })
            }
        },
        watch: {
        },
        created: function () {
            this.initListData(1);
            this.initPermission();
        }
    }
</script>

<style scoped>
    .layout {
        background: #fff;
        border-radius: 8px;
        padding: 5px 10px;
    }

    #layout-title {
        overflow: hidden;
        padding: 5px;
        font-size: 16px;
        border-bottom: 1px solid #e8eaec;
    }

    #box-search {
        padding-top: 20px;
    }

    #layout-title-left {
        float: left;
		display: flex;
		justify-content: center;
		align-items: center;
    }

    #layout-title-right {
        float: right;
    }

    #right-title {
        overflow: hidden;
        padding: 20px;
        font-size: 16px;
        border-bottom: 1px solid #e8eaec;
    }

    #head-img-ava {
        cursor: pointer;
        margin-left: 10px;
        margin-bottom: 20px;
    }

        #head-img-ava:hover {
            transform: scale(1.1);
        }

    #page-box {
        margin-top: 20px;
        text-align: center;
    }
	.modal-header{
		display: flex;
		justify-content: left;
		align-items: center;
	}
</style>
